import seoConfig from './pages.json';

export type SeoPage = { key: string; path: string; source: string };

export const { host, locales, defaultLocale } = seoConfig;
export const seoPages: SeoPage[] = seoConfig.pages;

/** Absolute URL of a page in a locale, in the canonical form (www host, no trailing slash). */
export const pageUrl = (locale: string, path: string) => `${host}/${locale}${path}`;

/**
 * Finds the indexable page behind a pathname such as `/fr/about-us` or `/fr/about-us/`.
 * Returns null for anything that must not be indexed (private pages, login, unknown paths).
 */
export function findSeoPage(pathname: string): { locale: string; page: SeoPage } | null {
  const [, locale = '', ...rest] = pathname.replace(/\/+$/, '').split('/');
  if (!locales.includes(locale)) return null;
  const path = rest.length ? `/${rest.join('/')}` : '';
  const page = seoPages.find((p) => p.path === path);
  return page ? { locale, page } : null;
}
